import "./BasisOfQuotationComponent.scss";
import template from "./BasisOfQuotationComponent.html";
import {IComponentOptions} from "angular";

export const BasisOfQuotation = "tfBasisOfQuotation";

export function basisOfQuotation(): IComponentOptions {
    return {
        template,
        bindings: {
            basis: "<"
        },
        controllerAs: "ctrl",
        controller: BasisOfQuotationComponentController
    };
}

export class BasisOfQuotationComponentController {
    public basisOfQuotation: string;
}
